import { EstadosPreagendamientoCodigoEnum, EstadosPreagendamientoPagoEnum } from "@/shared/interfaces";

export const SI_NO_CHOICE: { text: string, value: string }[] = [
  {
    value: 'true',
    text: 'SI'
  },
  {
    value: 'false',
    text: 'NO'
  },
]

export enum TipoIdentificacionEnumChoice {
  CEDULA = 'CÉDULA',
  RUC = 'RUC',
  PASAPORTE = 'PASAPORTE',
}

export const TIPO_IDENTIFICACIONES_CHOICE = [
  TipoIdentificacionEnumChoice.CEDULA,
  TipoIdentificacionEnumChoice.RUC,
  //TipoIdentificacionEnumChoice.PASAPORTE,
];

export enum TipoServicioEnumChoice {
  FIBRA = 'FIBRA',
  RADIO = 'RADIO',

  INALAMBRICO = 'INALAMBRICO',
  WIRELESS = 'WIRELESS',
}

export const TIPO_SERVICIOS_CHOICE = [
  TipoServicioEnumChoice.RADIO,
  TipoServicioEnumChoice.FIBRA,
];

export const TIPO_SERVICIOS_CORPORATIVO_CHOICE = [
  TipoServicioEnumChoice.FIBRA,
  TipoServicioEnumChoice.RADIO,
  TipoServicioEnumChoice.WIRELESS,
];


export enum TipoPlanEnumChoice {
  HOGAR = 'HOGAR',
  PYMES = 'PYMES',
  ISP = 'ISP',
  CORPORATIVO = 'CORPORATIVO',
  INSTITUCIONAL = 'INSTITUCIONAL',
}


export enum TipoServicioContratado {
  INTERNET = 'INTERNET',
  DATOS = 'DATOS',
}
export const TIPO_SERVICIO_CONTRATADO_CHOICE = [
  TipoServicioContratado.INTERNET,
  TipoServicioContratado.DATOS,
];



export const TIPO_PLANES_CHOICE = [
  TipoPlanEnumChoice.HOGAR,
  TipoPlanEnumChoice.PYMES,
  TipoPlanEnumChoice.CORPORATIVO,
  TipoPlanEnumChoice.ISP,
  TipoPlanEnumChoice.INSTITUCIONAL,
];

export enum TipoDescuentoEnumChoice {
  PORCENTAJE = 'PORCENTAJE',
  VALOR = 'VALOR',
}

export enum EstadosLlamadaEnumChoice {
  EN_ESPERA = 'EN ESPERA',
  REALIZADA = 'REALIZADA',
  NO_REALIZADA = 'NO REALIZADA',
  NO_CONTESTA = 'NO CONTESTA',
  MENSAJE_WHATSSAPP = 'MENSAJE DE WHATSAPP',
}

export enum EstadosActivacionEnumChoice {
  EN_ESPERA = 'En Espera',
  PRE_RECHAZADA = 'Activado',
  RECHAZADA = 'Rechazado',
  GESTIONADA = 'Gestionada',
  CANCELADO = 'Cancelado',
  FINALIZADO = 'Finalizado',
  PENDIENTE_CAMBIO_PUERTO = 'Pendiente Cambio Puerto',
}

export const ESTADOS_LLAMADAS_CHOICE = [
  EstadosLlamadaEnumChoice.EN_ESPERA,
  EstadosLlamadaEnumChoice.REALIZADA,
  //EstadosLlamadaEnumChoice.NO_REALIZADA,
  EstadosLlamadaEnumChoice.NO_CONTESTA,
  // EstadosLlamadaEnumChoice.MENSAJE_WHATSSAPP,
];

export enum EstadosProcesoEnumChoice {
  EN_ESPERA = 'EN ESPERA',
  EN_PROCESO = 'EN PROCESO',
  FINALIZADO = 'FINALIZADO',
  CANCELADO = 'CANCELADO',
  ABIERTO = "ABIERTO",
  PARCIAL = "PARCIAL"
}


export enum EstadosSolicitudEnumChoice {
  EN_ESPERA = 'EN ESPERA',
  APROBADO = 'APROBADO',
  ABIERTO = 'ABIERTO',
  BORRADOR = 'BORRADOR',
  RECHAZADO = 'RECHAZADO',
  CANCELADO = 'CANCELADO',
  FINALIZADO = 'FINALIZADO',
}

export const ESTADOS_SOLICITUDES_CHOICE = [
  EstadosSolicitudEnumChoice.EN_ESPERA,
  EstadosSolicitudEnumChoice.APROBADO,
  EstadosSolicitudEnumChoice.RECHAZADO,
  EstadosSolicitudEnumChoice.CANCELADO,
  EstadosSolicitudEnumChoice.FINALIZADO,
];

export enum UnidadesVelocidadEnumChoice {
  KB = 'KB',
  MB = 'MB',
  GB = 'GB',
  TB = 'TB',
}

export const UNIDADES_VELOCIDAD_CHOICE = [
  UnidadesVelocidadEnumChoice.KB,
  UnidadesVelocidadEnumChoice.MB,
  UnidadesVelocidadEnumChoice.GB,
  UnidadesVelocidadEnumChoice.TB,
];

export enum PermanenciasEnumChoice {
  DOCE_MESES = '12 MESES',
  VEINTICUATRO_MESES = '24 MESES',
  TREINTAYSEIS_MESES = '36 MESES',
  CUARENTAYOCHO_MESES = '48 MESES',
  SESENTA_MESES = '60 MESES',
}

export const PERMANENCIAS_CHOICE = [
  PermanenciasEnumChoice.DOCE_MESES,
  PermanenciasEnumChoice.VEINTICUATRO_MESES,
  PermanenciasEnumChoice.TREINTAYSEIS_MESES,
  PermanenciasEnumChoice.CUARENTAYOCHO_MESES,
  PermanenciasEnumChoice.SESENTA_MESES,
];

export const TIEMPO_CONTRATO_PYMES = [
  PermanenciasEnumChoice.DOCE_MESES,
  PermanenciasEnumChoice.VEINTICUATRO_MESES,
  PermanenciasEnumChoice.TREINTAYSEIS_MESES
]


export enum UserRolesEnumChoice {
  GERENCIA = 'GERENCIA',
  ADMINISTRADOR = 'ADMINISTRADOR',
  SUPERVISOR = 'SUPERVISOR',
  OBSERVADOR = 'OBSERVADOR',
  ADMINISTRATIVO = 'ADMINISTRATIVO',
  AGENTE = 'AGENTE',
}

export const USER_ROLES_CHOICE = [
  UserRolesEnumChoice.GERENCIA,
  UserRolesEnumChoice.ADMINISTRADOR,
  UserRolesEnumChoice.SUPERVISOR,
  UserRolesEnumChoice.OBSERVADOR,
  UserRolesEnumChoice.ADMINISTRATIVO,
  UserRolesEnumChoice.AGENTE,
];

export enum RecurrenciasEnumChoice {
  UNICO = 'UNICO',
  DIARIO = 'DIARIO',
  SEMANAL = 'SEMANAL',
  QUINCENAL = 'QUINCENAL',
  MENSUAL = 'MENSUAL',
  BIMENSUAL = 'BIMENSUAL',
  TRIMESTRAL = 'TRIMESTRAL',
  SEMESTRAL = 'SEMESTRAL',
  ANUAL = 'ANUAL',
}

export const RECURRENCIAS_CHOICE = [
  RecurrenciasEnumChoice.UNICO,
  RecurrenciasEnumChoice.DIARIO,
  RecurrenciasEnumChoice.SEMANAL,
  RecurrenciasEnumChoice.QUINCENAL,
  RecurrenciasEnumChoice.MENSUAL,
  RecurrenciasEnumChoice.BIMENSUAL,
  RecurrenciasEnumChoice.TRIMESTRAL,
  RecurrenciasEnumChoice.SEMESTRAL,
  RecurrenciasEnumChoice.ANUAL,
];

export enum MetodosAceptacionEnumChoice {
  FOTO = 'FOTO',
  VIDEO = 'VIDEO',
  LLAMADA = 'LLAMADA',
  MENSAJE = 'MENSAJE',
  CORREO = 'CORREO',
  WHATSAPP = 'WHATSAPP',
  CONTRATO_DIGITAL = 'CONTRATO DIGITAL',
}

export const METODOS_ACEPTACION_CHOICE = [
  MetodosAceptacionEnumChoice.FOTO,
  MetodosAceptacionEnumChoice.CONTRATO_DIGITAL,
  MetodosAceptacionEnumChoice.VIDEO,
  MetodosAceptacionEnumChoice.LLAMADA,
  MetodosAceptacionEnumChoice.MENSAJE,
  MetodosAceptacionEnumChoice.CORREO,
  MetodosAceptacionEnumChoice.WHATSAPP,
];

export enum TipoCuentaBancariaEnumChoice {
  CORRIENTE = 'CORRIENTE',
  AHORRO = 'AHORRO',
  AMIGA = 'AMIGA',
}

export const TIPO_CUENTA_BANCARIA_CHOICE = [
  TipoCuentaBancariaEnumChoice.CORRIENTE,
  TipoCuentaBancariaEnumChoice.AHORRO,
  TipoCuentaBancariaEnumChoice.AMIGA,
];

export enum TipoReferidoEnumChoice {
  CLIENTE = 'CLIENTE',
  AGENTE = 'AGENTE',
  EMPLEADO = 'EMPLEADO',
  SOCIO = 'SOCIO',
  PROVEEDOR = 'PROVEEDOR',
  OTRO = 'OTRO',
  FLOTA = 'FLOTA',
}

export const TIPO_REFERIDO_CHOICE = [
  TipoReferidoEnumChoice.CLIENTE,
  TipoReferidoEnumChoice.AGENTE,
  TipoReferidoEnumChoice.EMPLEADO,
  TipoReferidoEnumChoice.SOCIO,
  TipoReferidoEnumChoice.PROVEEDOR,
  TipoReferidoEnumChoice.OTRO,
  TipoReferidoEnumChoice.FLOTA,
];

export const TIPO_REFERIDO_PREVENTA_CHOICE: TipoReferidoEnumChoice[] = [
  TipoReferidoEnumChoice.CLIENTE,
  TipoReferidoEnumChoice.FLOTA,
  TipoReferidoEnumChoice.EMPLEADO,
];

export const ESTADO_PREAGENDAMIENTO_PYL: EstadosPreagendamientoCodigoEnum[] = [
  EstadosPreagendamientoCodigoEnum.ESPERA,
  EstadosPreagendamientoCodigoEnum.PAUSADO,
]


export const ESTADO_PAGO_PREAGENDAMIENTO_PYL: EstadosPreagendamientoPagoEnum[] = [
  EstadosPreagendamientoPagoEnum.PENDIENTE,
  EstadosPreagendamientoPagoEnum.PAGADO,
  EstadosPreagendamientoPagoEnum.PAGADO_DEBITO,
]


export enum TipoEmpleadoEnumChoice {
  TECNICO = 'TÉCNICO',
  VENDEDOR = 'VENDEDOR',
  SUPERVIDOR = 'SUPERVISOR',
  ADMINISTRATIVO = 'ADMINISTRATIVO',
  COMERCIAL = 'COMERCIAL',
  OPERATIVO = 'OPERATIVO',
  LOGISTICO = 'LOGÍSTICO',
  OTRO = 'OTRO',
}

export const TIPO_EMPLEADO_CHOICE = [
  TipoEmpleadoEnumChoice.TECNICO,
  TipoEmpleadoEnumChoice.SUPERVIDOR,
  TipoEmpleadoEnumChoice.VENDEDOR,
  TipoEmpleadoEnumChoice.ADMINISTRATIVO,
  TipoEmpleadoEnumChoice.COMERCIAL,
  TipoEmpleadoEnumChoice.OPERATIVO,
  TipoEmpleadoEnumChoice.LOGISTICO,
  TipoEmpleadoEnumChoice.OTRO,
];

export enum TipoFormaPagoEnumChoice {
  EFECTIVO = 'EFECTIVO',
  TARJETA = 'TARJETA',
  TRANSFERENCIA = 'TRANSFERENCIA',
  DEPOSITO = 'DEPÓSITO',
  DEBITO = 'DÉBITO',
  RECAUDACION = 'RECAUDACIÓN',
  CHEQUE = 'CHEQUE',
  PAGO_MOVIL = 'PAGO MÓVIL',
  MIXTO = 'MIXTO',
  NOTA_CREDITO = 'NOTA CREDITO',
  OTRO = 'OTRO',
}

export const TIPO_FORMA_PAGO_CHOICE = [
  TipoFormaPagoEnumChoice.EFECTIVO,
  TipoFormaPagoEnumChoice.TARJETA,
  TipoFormaPagoEnumChoice.TRANSFERENCIA,
  TipoFormaPagoEnumChoice.DEPOSITO,
  TipoFormaPagoEnumChoice.DEBITO,
  TipoFormaPagoEnumChoice.RECAUDACION,
  TipoFormaPagoEnumChoice.CHEQUE,
  TipoFormaPagoEnumChoice.PAGO_MOVIL,
  TipoFormaPagoEnumChoice.OTRO,
];

export enum TiposUsoIpEnumChoice {
  ESTATICO = 'ESTÁTICO',
  DINAMICO = 'DINÁMICO',
}

export const TIPOS_USO_IP_CHOICE = [
  TiposUsoIpEnumChoice.ESTATICO,
  TiposUsoIpEnumChoice.DINAMICO,
];

export enum TiposRouterEnumChoice {
  MIKROTIK = 'MIKROTIK',
  HUAWEI = 'HUAWEI',
}
export const TIPOS_ROUTER_CHOICE = [TiposRouterEnumChoice.MIKROTIK, TiposRouterEnumChoice.HUAWEI];

export enum EstadosAgendamientoEnumChoice {
  EN_ESPERA = 'EN ESPERA',
  APROBADO = 'APROBADO',
  REAGENDADO = 'REAGENDADO',
  RECORDINADO = 'RECORDINADO',
  FINALIZADO = 'FINALIZADO',
  CANCELADO = 'CANCELADO',
  PRERECHAZADO = 'PRE-RECHAZADO',
  PENDIENTE_TECNICO = 'PENDIENTE TECNICO',
  PENDIENTE_RECORDINACION = 'PENDIENTE_RECORDINACION', // from ot reject
  ALL = 'VER TODO',
  GESTION_VENTA = 'GESTION VENTA',
  TRASLADO_EN_ESPERA = 'TRASLADO_EN_ESPERA',
  EN_PAUSA = 'PAUSADO',
}

export const ESTADOS_AGENDAMIENTO_CHOICE = [
  EstadosAgendamientoEnumChoice.EN_ESPERA,
  EstadosAgendamientoEnumChoice.APROBADO,
  EstadosAgendamientoEnumChoice.REAGENDADO,
  EstadosAgendamientoEnumChoice.RECORDINADO,
  EstadosAgendamientoEnumChoice.FINALIZADO,
  EstadosAgendamientoEnumChoice.CANCELADO,
  EstadosAgendamientoEnumChoice.PENDIENTE_RECORDINACION,
];
export enum TipoContribuyenteRucChoice {
  PERSONA_NATURAL = 'PERSONA NATURAL',
  SOCIEDAD = 'SOCIEDAD'
}

export const TIPO_CONTRIBUYENTE_RUC_CHOICE: TipoContribuyenteRucChoice[] = [
  TipoContribuyenteRucChoice.PERSONA_NATURAL,
  TipoContribuyenteRucChoice.SOCIEDAD,
]

export enum EstadosPreagendamientoEnumChoice {
  EN_ESPERA = 'EN ESPERA',
  APROBADO = 'APROBADO',
  RECHAZADO = 'RECHAZADO', // pendiente actualizacion - PyL solicita actualizacion, NO bloquea el flujo
  PRERECHAZADO = 'PRE-RECHAZADO',
  PENDIENTE_REAGENDAR = 'PENDIENTE_REAGENDAR',
  REAGENDADO = 'REAGENDADO',
  PENDIENTE_PAGO = 'PENDIENTE_PAGO',
  FINALIZADO = 'FINALIZADO',
  CANCELADO = 'CANCELADO',
  EN_PAUSA = 'PAUSADO', // PARA CUANDO EL ESTADO DE LLAMADA ES NO CONTESTADO
  PENDIENTE_TECNICO = 'PENDIENTE TECNICO',
  RECORDINADO = 'RECORDINADO'
}

export const ESTADOS_PREAGENDAMIENTO_CHOICE = [
  EstadosPreagendamientoEnumChoice.EN_ESPERA,
  EstadosPreagendamientoEnumChoice.APROBADO,
  EstadosPreagendamientoEnumChoice.RECHAZADO,
  EstadosPreagendamientoEnumChoice.PENDIENTE_REAGENDAR,
  EstadosPreagendamientoEnumChoice.REAGENDADO,
  EstadosPreagendamientoEnumChoice.PENDIENTE_PAGO,
  EstadosPreagendamientoEnumChoice.FINALIZADO,
  EstadosPreagendamientoEnumChoice.CANCELADO,
];
export enum TipoEntidadOrdenServicioEnumChoice {
  VISITA = 'VISITA'
}
export enum EstadosOrdenTrabajoEnumChoice {
  EN_ESPERA = 'EN ESPERA',
  ESPERA_RECOORDINADA = 'ESPERA_RECOORDINADA', // pasa a realizada
  ESPERA_ACTUALIZAR = 'ESPERA_ACTUALIZAR',
  PRE_RECHAZADO = 'PRE-RECHAZADO',
  RECHAZADA = 'RECHAZADA',

  REALIZADA = 'REALIZADA', // tecnico cierra la OT - change client state
  REALIZADA_ACTUALIZADA = 'REALIZADA_ACTUALIZADA',
  REALIZADA_APROBADA = 'REALIZADA APROBADA',
}
export const ESTADOS_ORDEN_TRABAJO_CHOICE = [
  EstadosOrdenTrabajoEnumChoice.EN_ESPERA,
  EstadosOrdenTrabajoEnumChoice.ESPERA_RECOORDINADA,
  EstadosOrdenTrabajoEnumChoice.ESPERA_ACTUALIZAR,
  EstadosOrdenTrabajoEnumChoice.REALIZADA,
  EstadosOrdenTrabajoEnumChoice.REALIZADA_ACTUALIZADA,
  EstadosOrdenTrabajoEnumChoice.PRE_RECHAZADO,
  EstadosOrdenTrabajoEnumChoice.RECHAZADA,
  EstadosOrdenTrabajoEnumChoice.REALIZADA_APROBADA,
];

export enum EstadosActivacionInstallOTEnumChoice {
  EN_ESPERA = 'EN ESPERA',
  GESTIONADA = 'GESTIONADA',

  PENDIENTE_CAMBIO_DATOS = 'PENDIENTE CAMBIO DATOS',
  PENDIENTE_HORA_FIN = 'PENDIENTE HORA FIN',
  PENDIENTE_CAMBIO_PUERTO = 'PENDIENTE_CAMBIO_PUERTO',

  REALIZADO_ACTIVACION = 'REALIZADO ACTIVACION',
  RECHAZADA = 'RECHAZADA',
}

export enum ModulosEnumChoice {
  PROSPECTO = 'PROSPECTO',
  PREVENTA = 'PREVENTA',
  PREAGENDAMIENTO = 'PREAGENDAMIENTO',
  AGENDAMIENTO = 'AGENDAMIENTO',
  RECORDINADO = 'RECORDINADO',
  ORDEN_TRABAJO = 'ORDEN TRABAJO',
  CONTRATOS = 'CONTRATOS',
  BITACORA = 'BITACORA',
  PROSPECTO_CORPORATIVO = 'PROSPECTO CORPORATIVO',
  PREVENTA_CORPORATIVO = 'PREVENTA CORPORATIVO',
  FACTIBILIDAD_CORPORATIVO = 'FACTIBILIDAD CORPORATIVO',
  AGENDAMIENTO_CORPORATIVO = 'AGENDAMIENTO CORPORATIVO',
  ORDEN_SERVICIO_CORPORATIVO = 'ORDEN DE SERVICIO CORPORATIVO',
  MANTENIMIENTO = "MANTENIMIENTO",//PLANTA EXTERNA
  ACTIVACIONES = "ACTIVACIONES",
  OPERACIONES = "OPERACIONES",
  // FACTIBILIDAD_CORPORATIVO_SUPERVISOR = 'FACTIBILIDAD CORPORATIVO_SUPERVISOR',
  PROSPECTO_PYMES = 'PROSPECTO PYMES',
  PREVENTA_PYMES = 'PREVENTA PYMES',
  PREAGENDAMIENTO_PYMES = 'PREAGENDAMIENTO PYMES',
  PLANTA_EXTERNA = 'PLANTA EXTERNA',
  COMPRAS = 'COMPRAS',
  PEDIDOS = 'PEDIDOS'
}

export enum ModulosCargarDocumentoEnumChoice {
  RADIO_BASE = 'RADIO BASE',
}

export const MODULOS_CHOICE_CARGAR_DOCUMENTACION: ModulosCargarDocumentoEnumChoice[] = [
  ModulosCargarDocumentoEnumChoice.RADIO_BASE,
];

export const MODULOS_CHOICE = [
  ModulosEnumChoice.PROSPECTO,
  ModulosEnumChoice.PREVENTA,
  ModulosEnumChoice.PREAGENDAMIENTO,
  ModulosEnumChoice.AGENDAMIENTO,
  ModulosEnumChoice.ORDEN_TRABAJO,
];

export enum PrioridadIncidenciaEnum {
  BAJA = 'BAJA',
  MEDIA = 'MEDIA',
  ALTA = 'ALTA',
};
export const PRIORIDAD_INCIDENCIA_CHOICE = [
  PrioridadIncidenciaEnum.BAJA,
  PrioridadIncidenciaEnum.MEDIA,
  PrioridadIncidenciaEnum.ALTA,
];

export const TipoProductoEnumChoice = {
  INVENTARIABLE: 'INVENTARIABLE',
  GASTOS: 'GASTOS',
  COSTOS: 'COSTOS',
  VENTAS: 'VENTAS',
  ACTIVOS: 'ACTIVOS',
};

export const TIPO_PRODUCTO_CHOICE = [
  TipoProductoEnumChoice.INVENTARIABLE,
  TipoProductoEnumChoice.GASTOS,
  TipoProductoEnumChoice.VENTAS,
  TipoProductoEnumChoice.COSTOS,
  TipoProductoEnumChoice.ACTIVOS,
];

export enum TipoContratoEnumChoice {
  GEDATECU = 'GEDATECU',
  ELINA_MOROCHO = 'ELIANA MOROCHO',
}

export enum EstadosPagoEnumChoice {
  PENDIENTE = 'PENDIENTE',
  PAGADO = 'PAGADO',
  ANULADO = 'ANULADO',
}

export enum EquiposAdicionalesCodigoEnumChoice {
  WIFI_6 = 'WIFI_6',
  ROUTER_AC = 'ROUTER_AC',
}

export const EQUIPO_ADICIONAL_VENTA_CHOICE: EquiposAdicionalesCodigoEnumChoice[] =
  [
    EquiposAdicionalesCodigoEnumChoice.WIFI_6,
    EquiposAdicionalesCodigoEnumChoice.ROUTER_AC,
  ];

export const EstadoOTPChoiceEnum = {
  PENDIENTE: 'PENDIENTE',
  VERIFICADO: 'VERIFICADO',
  EXPIRADO: 'EXPIRADO',
  SOLICITADO: 'SOLICITADO',
  RECHAZADO: 'RECHAZADO'
};

export enum TrazabilidadAccionChoiceEnum {
  CREACION = 'CREACION',
  SOLICITUD_NO_COBRO_INSTALACION = 'SOLICITUD NO COBRO INSTALACION',
  AGENDAMIENTO = 'AGENDAMIENTO',
};

///* OT - Fotos --------------------------
export enum EstadosImagenChoiceEnum {
  NO_CARGADO = 'NO_CARGADO',
  CARGADO = 'CARGADO',

  // estado_imagen_actualizacion
  UPD_SOLICITADA = 'UPD_SOLICITADA',
  UPD_REALIZADA = 'UPD_REALIZADA',
  UPD_APROBADA = 'UPD_APROBADA',
  UPD_AUDITADA_APROBADA = 'UPD_AUDITADA_APROBADA'
}

export enum EstadoPagoChoiceEnum {
  PENDIENTE = 'PENDIENTE',
  PAGADO = 'PAGADO',
  ANULADO = 'ANULADO',
}

export enum EstadoProspectoEnum {
  EN_ESPERA = 'EN ESPERA',
  EN_PROCESO = 'EN PROCESO',
  FINALIZADO = 'FINALIZADO',
  CANCELADO = 'CANCELADO',
  FALLIDO = 'FALLIDO'
}

export enum EstadoPreventaEnum {
  EN_ESPERA = 'EN ESPERA',
  EN_PROCESO = 'EN PROCESO',
  FINALIZADO = 'FINALIZADO',
  CANCELADO = 'CANCELADO',
  SOLICITUD_CORRECCION = 'SOLICITUD CORRECCION',
  PREAGENDADO = 'EN PROCESO',
  CORREGIDO = 'CORREGIDO',
  PREAPROBADA = 'PREAPROBADA',
  PRE_RECHAZADO = 'PRE-RECHAZADO',
  PENDIENTE_DOCUMENTOS = 'PENDIENTE DOCUMENTOS'
}

export enum EstadoFactibilidadEnum {
  PENDIENTE = 'PENDIENTE',
  APROBADO = 'APROBADO',
  NEGADO = 'NEGADO',
  EN_GESTION = 'EN GESTION',
  FINALIZADO = 'FINALIZADO',
  CANCALADO = 'CANCELADO',
  PRE_RECHAZADO = 'PRE-RECHAZADO',
}


export enum EstadosPreventaEnum {
  ESPERA = 'EN ESPERA',
  PREAGENDADO = 'EN PROCESO',
  REALIZADO = 'FINALIZADO',
  RECHAZADO = 'CANCELADO',
  SOLICITUDCORRECCION = 'SOLICITUD CORRECCION',//Solicitud Corrección
  CORREGIDO = 'CORREGIDO',
}


export const ESTADO_PAGO_CHOICE: EstadoPagoChoiceEnum[] = [
  EstadoPagoChoiceEnum.PENDIENTE,
  EstadoPagoChoiceEnum.PAGADO,
  EstadoPagoChoiceEnum.ANULADO,
]

export enum EstadoValidacionPreventaEnum {
  FOTOS_NO_COINCIDEN = 'FOTOS NO COINCIDEN',
  CODIGO_DACTILAR_NO_COINCIDEN = 'CODIGO DACTILAR NO COINCIDEN',
  FOTO_CEDULA_TRASERA_BORROSA = 'FOTO CEDULA TRASERA BORROSA',
  CORREJIDO = 'CORREJIDO',
}

export const ESTADO_VALIDACION_PREVENTA_CHOICE: EstadoValidacionPreventaEnum[] =
  [
    EstadoValidacionPreventaEnum.FOTOS_NO_COINCIDEN,
    EstadoValidacionPreventaEnum.CODIGO_DACTILAR_NO_COINCIDEN,
    EstadoValidacionPreventaEnum.FOTO_CEDULA_TRASERA_BORROSA,
  ];

export enum EstadosContribuyenteRucENUM {
  ACTIVO = 'ACTIVO',
  SUSPENDIDO = 'SUSPENDIDO',
}

export enum ModulosMotivoENUM {
  TRASLADO_INVENTARIO = 'TRASLADO_INVENTARIO',
  INGRESO_INVENTARIO = 'INGRESO_INVENTARIO',
  EGRESO_INVENTARIO = 'EGRESO_INVENTARIO',

  //CORRECCIÓN DE DATA DESDE MÓDULO CLIENTE
  ACTUALIZAR_CLIENTE_DATOS = 'ACTUALIZAR DATOS CLIENTES',
  BITACORA_PYL = "BITACORA PYL",
  BITACORA_VENTA = "BITACORA VENTA",
  REINGRESO_SERIES = "REINGRESO_SERIES",
  //BITACORA = "BITACORA VENTA"
}
export enum BitacoraPrioridadENUM {
  ALTA = 'ALTA',
  MEDIA = 'MEDIA',
  BAJA = 'BAJA'
}
export enum EstadosContratoChoiceEnum {
  EN_ESPERA = 'EN ESPERA',
  ACTIVO = 'ACTIVO',
  INACTIVO = 'INACTIVO',
  CANCELADO = 'CANCELADO',
  FINALIZADO = 'FINALIZADO',
  SUSPENDIDO = 'SUSPENDIDO',
  RECHAZADO = 'RECHAZADO',

  RETENCION = 'RETENCION',

  SOLICITUD_CORRECCION = 'SOLICITUD CORRECCION',
  CORREGIDO = 'CORREGIDO',

  // helper state not included in db
  ALL = 'VER TODOS',
}

export const ESTADOS_CONTRATO_CHOICE: EstadosContratoChoiceEnum[] = [
  EstadosContratoChoiceEnum.EN_ESPERA,
  EstadosContratoChoiceEnum.ACTIVO,
  EstadosContratoChoiceEnum.INACTIVO,
  EstadosContratoChoiceEnum.CANCELADO,
  EstadosContratoChoiceEnum.FINALIZADO,
  EstadosContratoChoiceEnum.SUSPENDIDO,
  EstadosContratoChoiceEnum.RECHAZADO,
  EstadosContratoChoiceEnum.RETENCION,

  // helper state not included in db
  EstadosContratoChoiceEnum.ALL,
];

export enum EstadosEquipoChoiceEnum {
  NUEVO = 'Nuevo',
  USADO = 'Usado',
  REPARADO = 'Reparado',
  RENOVADO = 'Renovado',
  RECICLADO = 'Reciclado',
  DESECHADO = 'Desechado',
}

export enum EstadosLiberacionValorInstalacionEnumChoice {
  EN_ESPERA = 'EN ESPERA',
  APROBADO = 'APROBADO',
  ABIERTO = 'ABIERTO',
  RECHAZADO = 'RECHAZADO',
  CANCELADO = 'CANCELADO',
  FINALIZADO = 'FINALIZADO',
}
export enum TipoRubroChoiceEnum {
  SERVICIO = 'SERVICIO',
  PRODUCTO = 'PRODUCTO',
  LIBRE = 'LIBRE',
}
export const TIPOS_RUBRO_CHOICE: TipoRubroChoiceEnum[] = [
  TipoRubroChoiceEnum.SERVICIO,
  // TipoRubroChoiceEnum.PRODUCTO,
  TipoRubroChoiceEnum.LIBRE,
];

export enum EstadosRubroChoiceEnum {
  NO_PAGADO = 'NO_PAGADO',
  PAGADO = 'PAGADO',
  PAGO_INCOMPLETO = 'PAGO_INCOMPLETO',
  VENCIDO = 'VENCIDO',
  ANULADO = 'ANULADO',
}

export const ESTADOS_RUBRO_CHOICE: EstadosRubroChoiceEnum[] = [
  EstadosRubroChoiceEnum.NO_PAGADO,
  EstadosRubroChoiceEnum.PAGADO,
  EstadosRubroChoiceEnum.PAGO_INCOMPLETO,
  EstadosRubroChoiceEnum.VENCIDO,
  EstadosRubroChoiceEnum.ANULADO,
];

export enum EstadoSaldoChoiceEnum {
  FACTURADO = 'FACTURADO',
  NO_FACTURADO = 'NO_FACTURADO',
}

export enum TipoParametroChoiceEnum {
  TEXTO = 'TEXTO',
  NUMERICO = 'NUMÉRICO',
  BOOLEANO = 'BOOLEANO',
  MODELO = 'MODELO', // modelo db - code
  FECHA = 'FECHA',
  HORA = 'HORA',
  JSON = 'JSON',
  ARRAY = 'ARRAY',
  IMAGE = 'IMAGE',
}

export const TIPO_PARAMETRO_CHOICE: TipoParametroChoiceEnum[] = [
  TipoParametroChoiceEnum.TEXTO,
  TipoParametroChoiceEnum.NUMERICO,
  TipoParametroChoiceEnum.FECHA,
  TipoParametroChoiceEnum.HORA,
  TipoParametroChoiceEnum.BOOLEANO,
  TipoParametroChoiceEnum.JSON,
  TipoParametroChoiceEnum.ARRAY,
  TipoParametroChoiceEnum.MODELO,
];

export enum EstadoReferidoChoiceEnum {
  ACEPTADO = 'ACEPTADO',
  RECHAZADO = 'RECHAZADO',
  PENDIENTE = 'PENDIENTE'
}

export enum BucketAwtENUM {
  IMAGE_INVENTARIO = 'image/inventariable',
  IMAGE_IDENTIFICACION = 'image/identificacion',
  IMAGE_CUENTA_BANCARIA = 'image/cuenta-bancaria',
  IMAGE_TARJETA = 'image/tarjeta',
  IMAGE_COMPRABANTE_PAGO = 'image/comprobante-pago',
  IMAGE_CONTRATO = 'image/contrato',
  IMAGE_EMPRESA_LOGO = 'image/empresa-logo',
  IMAGE_INSTALACION = 'image/instalacion',
  IMAGE_SOLICITUD_BENEFICIO_TUTOR = 'image/solicitud-beneficio/tutor-discapacidad',
  IMAGE_SOLICITUD_BENEFICIO_BONO = 'image/solicitud-beneficio/bono-desarrollo',
  IMAGE_CLIENTE_CORPORATIVO = 'image/corporativo',
  IMEGE_CHAT = 'image/chat',
  IMEGE_TEST = 'image/test',
  DOCUMENTOS_CORPORATIVO = 'documento/corporativo',
  INSPECCION_CORPORATIVO = 'documento/inspeccion-corporativo',
  PROPUESTA_TECNICA = 'documento/propuesta-tecnica-corporativo',
  PREFACTIBILIDAD_CORPORATIVO = 'documento/anexo-prefactibilidad',
  DOCUMENTO_SERIE = 'documento/serie',
  DOCUMENTO_INVENTARIABLE = 'documento/inventariable',
  IMAGE_SOLICITUD_COMPRA = 'image/solicitud-compra',
  DOCUMENTO_SOLICITUD_COMPRA = 'documento/solicitud-compra',
  IMAGE_REVISION_SOLIICTUD_COMPRA = 'image/revision-solicitud-compra',
  DOCUMENTO_REVISION_SOLICITUD_COMPRA = 'documento/revision-solicitud-compra',
  IMAGE_ORDEN_COMPRA = 'image/orden-compra',
  DOCUMENTO_ORDEN_COMPRA = 'documento/orden-compra',
  IMAGE_REVISION_ORDEN = 'image/revision-orden-compra',
  DOCUMENTO_REVISION_ORDEN_COMPRA = 'documento/revision-orden-compra',
  DOCUMENTO_PYEMES = 'documento/pymes',
  CONTRATO_FISICO = 'pdf/contrato-fisico',
  DOCUMENTO_PROVEEDOR = 'documento/proveedor',
  DOCUMENTO_REGISTRO_FACTURA = 'documento/registro-factura',
  DOCUMENTOS_PREVENTA_CORPORATIVA = 'documento/preventa-corporativa',
  DOCUMENTOS_SOLUCION_COSTEADA_CORPORATIVA = 'documento/solucion-costeada-corporativa',
  DOCUMENTO_SOLICITUD_EGRESO = 'documento/solicitud_egreso',
  DOCUMENTO_SOLICITUD_PEDIDO = 'documento/solicitud_pedido'
}

export enum IvaENUM {
  IVA = 0.15,
}

export enum plantillaExcelENUM {
  PLANTILLA_SECTOR = '/excel/plantilla_sectores_cobertura.xlsx',
  PLANTILLA_NODO = '/excel/plantilla_nodo.xlsx',
  PLANTILLA_RADIO_BASE = '/excel/plantilla_radio_bases.xlsx',
  PLANTILLA_OLT = '/excel/plantilla_olt.xlsx',
  PLANTILLA_OLT_TRONCALES = '/excel/plantilla_olt_troncales.xlsx',
  PLANTILLA_INVENTARIABLE = '/excel/plantilla_inventariable.xlsx',
  PLANTILLA_SERIE_EXCEL = '/excel/plantilla_serie_excel.xlsx',
  PLANTILLA_SERIE_TXT = '/excel/plantilla_serie_txt.txt',
  PLANTILLA_PROVEEDOR = '/excel/plantilla_proveedor.xlsx',
  PLANTILLA_RADIUS_MIGRACION = '/excel/plantilla_radius_migracion.xlsx',

}

export enum RolChoiceEnum {
  SUPERVISOR = 'SUPERVISOR',
  AGENTE = 'AGENTE',
}

export const ROL_CHOICE: RolChoiceEnum[] = [
  RolChoiceEnum.SUPERVISOR,
  RolChoiceEnum.AGENTE
]

export const enum SegmentacionENUM {
  NO_DATA = 'NO DATA',
  AAA = 'AAA',
  AA = 'AA',
  A = 'A',
  RECHAZAR = 'RECHAZAR'
}

export const SEGMENTACION_CHOICE: SegmentacionENUM[] = [
  SegmentacionENUM.A,
  SegmentacionENUM.AA,
  SegmentacionENUM.AAA,
  SegmentacionENUM.RECHAZAR,
  SegmentacionENUM.NO_DATA,
]

export enum EstadoLiberarVentaENUM {
  APROBADO = 'APROBADO',
  EN_ESPERA = 'EN ESPERA',
  CANCELADO = 'CANCELADO',
}

export enum EntidadFinancieraENUM {
  GUAYAQUIL = 'GUAYAQUIL',
  COOP_JEP = 'COOP JEP'
}

export enum TipoPuertoDisponiblesENUM {
  OPTIMO_1G = 'OPTIMO 1G',
  ELECTRICO = 'ELECTRICO',
  OPTIMO_10G = 'OPTIMO 10G'
}

export const TIPO_PUERTO_DISPONIBLE_CHOICE: TipoPuertoDisponiblesENUM[] = [
  TipoPuertoDisponiblesENUM.ELECTRICO,
  TipoPuertoDisponiblesENUM.OPTIMO_10G,
  TipoPuertoDisponiblesENUM.OPTIMO_1G
]

export enum TipoComparticion {
  'UNO_UNO' = '1:1',
  'DOS_UNO' = '2:1'
}

export const TIPO_COMPORTICION_CHOICE: TipoComparticion[] = [
  TipoComparticion.UNO_UNO,
  TipoComparticion.DOS_UNO,
]

export enum TipoEnlaceENUM {
  SIMETRICO = 'SIMÉTRICO',
  ASIMETRICO = 'ASIMÉTRICO',
  PRINCIAPL = 'PRINCIPAL',
  BACKUP = 'BACKUP'
}
export const TIPO_ENLACE_CHOICE: TipoEnlaceENUM[] = [
  TipoEnlaceENUM.SIMETRICO,
  TipoEnlaceENUM.ASIMETRICO,
]
export enum EstadoSolicitudDeudaENUM {
  EN_ESPERA = 'EN ESPERA',
  APROBADO = 'APROBADO',
  ABIERTO = 'ABIERTO',
  RECHAZADO = 'RECHAZADO',
  CANCELADO = 'CANCELADO',
  FINALIZADO = 'FINALIZADO'
}


export enum EstadoFactibilidadCorporativaENUM {
  PENDIENTE = 'PENDIENTE',
  CORREGIDO = 'CORREGIDO',
  EN_REVISION = 'EN REVISION',
  EN_INSPECCION = 'EN INSPECCIÓN',
  INSPECCIONADO = 'INSPECCIONADO',
  APROBADO = 'APROBADO',
  DOCUMENTOS_CARGADOS = 'DOCUMENTOS CARGADOS',
  NEGADO = 'NEGADO',
  EN_GESTION = 'EN GESTION',
  FINALIZADO = 'FINALIZADO',
  CANCELADO = 'CANCELADO',
  PRE_RECHAZADO = 'PRE-RECHAZADO',
}

export const EstadoFactibilidadCorporativaChoices: EstadoFactibilidadCorporativaENUM[] = [
  EstadoFactibilidadCorporativaENUM.APROBADO,
  EstadoFactibilidadCorporativaENUM.CANCELADO,
  EstadoFactibilidadCorporativaENUM.EN_GESTION,
  EstadoFactibilidadCorporativaENUM.FINALIZADO,
  EstadoFactibilidadCorporativaENUM.NEGADO,
  EstadoFactibilidadCorporativaENUM.PENDIENTE,
  EstadoFactibilidadCorporativaENUM.EN_INSPECCION
]

export const CUOTAS_CHOICE = ['1', '2', '3', '4', '5', '6', '12', '24']

export const CANTIDAD_CHOICE = ['1', '2', '3', '4', '5', '6']

export const enum emailENUM {
  MANUALMENTE = 'INGRESAR MANUALMENTE'
}
export enum EstadoSolicitudExtranjero {
  EN_ESPERA = 'EN ESPERA',
  APROBADO = 'APROBADO',
  ABIERTO = 'ABIERTO',
  RECHAZADO = 'RECHAZADO',
  CANCELADO = 'CANCELADO',
  FINALIZADO = 'FINALIZADO'
}
export enum EstadoSolicitudAplicaGremios {
  EN_ESPERA = 'EN ESPERA',
  APROBADO = 'APROBADO',
  ABIERTO = 'ABIERTO',
  RECHAZADO = 'RECHAZADO',
  CANCELADO = 'CANCELADO',
  FINALIZADO = 'FINALIZADO'
}
export const ValorRadioBase = 47.61
export const ValorSinIvaRadioPymes = 65
export const ValorCompletoInstalacionSinIvaPymes = 100

export enum EstadoAgendaCorporativa {
  EN_ESPERA = 'EN ESPERA',
  APROBADO = 'APROBADO',
  PREAGENDADO = 'PREAGENDADO',
  RECORDINADO = 'RECORDINADO',
  FINALIZADO = 'FINALIZADO',
  CANCELADO = 'CANCELADO',
  PENDIENTE_RECORDINACION = 'PENDIENTE_RECORDINACION',
  PRE_RECHAZADO = 'PRE_RECHAZADO'
}

export enum RolesENUM {
  SUPERVISOR = 'SUPERVISOR',
  ADMINISTRATIVO = 'ADMINISTRATIVO',
  AGENTE = 'AGENTE'
}

export enum EstadoTransitoInventarioENUM {
  EN_ESPERA = 'EN ESPERA',
  EN_TRANSITO = 'EN TRANSITO',
  ENTREGADO = 'ENTREGADO',
  PENDIENTE_REGULACION = 'PENDIENTE REGULACION',
  PENDIENTE_DOCUMENTO = 'PENDIENTE DOCUMENTO',
  RECHAZADO = 'RECHAZADO'
}

export enum EstadoTomaFisicaENUM {
  BORRADOR = 'BORRADOR',
  EN_ESPERA = 'EN ESPERA',
  APROBADO = 'APROBADO',
  ABIERTO = 'ABIERTO',
  RECHAZADO = 'RECHAZADO',
  CANCELADO = 'CANCELADO',
  FINALIZADO = 'FINALIZADO'
}

export enum LocalidadENUM {
  PAIS = 'PAIS',
  PROVINCIA = 'PROVINCIA',
  CIUDAD = 'CIUDAD',
  ZONA = 'ZONA',
  SECTOR = 'SECTOR'
}

export enum EstadoEstadoStockENUM {
  CRITICO = 'CRITICO',
  AGOTADO = 'AGOTADO',
  NORMAL = 'NORMAL'
}



export enum EstadoOLT {
  DISPONIBLE = "DISPONIBLE",
  NO_DISPONIBLE = "NO DISPONIBLE",
  MANTENIMIENTO = "EN MANTENIMIENTO",
}

export const EstadoOLTOptions = [
  EstadoOLT.DISPONIBLE,
  EstadoOLT.NO_DISPONIBLE,
  EstadoOLT.MANTENIMIENTO
]

export enum TipoBeneficioENUM {
  TODOS = 'TODOS',
  FAMILIAR_DISCAPACIDAD = 'FAMILIAR CON DISCAPACIDAD',
  DESARROLLO_HUMANO = 'BONO DE DESARROLLO HUMANO',
  AYUDA_SOCIAL = 'AYUDA SOCIAL',
  REPORTADO = 'SCORE BAJO',
  REPORTADO_TELCO = 'REPORTADO POR TELCO',
  APLICA_GREMIO = 'APLICA GREMIO'
}

export const cantMaxPermitidoInventariable = 1000000;

export enum EstadoCuadreENUM {
  FINALIZADO = 'FINALIZADO',
  BORRADOR = 'BORRADOR',
  REVERSAR = 'REVERSAR',
}

export enum EstadoGestionInventarioENUM {
  TODOS = 'TODOS',
  NO_REQUIERE = 'NO REQUIERE',
  FIBRAPOINT = 'FIBRAPOINT',
  FALTANTE = 'FALTANTE',
  FACTURADO = 'FACTURADO',
}

export const OPCIONES_ESTADO_GESTION_INVENTARIO = [
  EstadoGestionInventarioENUM.NO_REQUIERE,
  EstadoGestionInventarioENUM.FIBRAPOINT,
  EstadoGestionInventarioENUM.FALTANTE,
  EstadoGestionInventarioENUM.FACTURADO,
];

export const FILTRO_ESTADO_GESTION_INVENTARIO = [
  EstadoGestionInventarioENUM.TODOS,
  EstadoGestionInventarioENUM.FIBRAPOINT,
  EstadoGestionInventarioENUM.FALTANTE,
  EstadoGestionInventarioENUM.FACTURADO,
];


export const OPCIONES_ESTADO_GESTION_INVENTARIO_EDITABLE = [
  EstadoGestionInventarioENUM.FIBRAPOINT,
  EstadoGestionInventarioENUM.FALTANTE,
  EstadoGestionInventarioENUM.FACTURADO,
];